<template>
  <span data-app>
    <div class="md-layout">
      <div class="md-layout-item ml-auto">
        <md-button
          :disabled="isNotCheckedOut"
          @click="
            itemToEdit = null
            createDialog = true
            keyCreate = keyCreate + 1
          "
          style="float: right;"
          class="md-warning"
        >
          <img
            :src="icons.createButton"
            style="height: 26px; width: 26px; margin-right: 10px;"
          />
          <span style="color: black;">{{ $t('intentsList.newIntents') }}</span>
        </md-button>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>list_alt</md-icon>
            </div>
            <h4 class="title inlineTitle">
              {{ $t('drawer.workspace.subitems.intents') }}
            </h4>
            <!-- <md-button
              :disabled="isNotCheckedOut"
              class="rightJustify md-simple md-github"
            >
              <md-icon>publish</md-icon>
              {{ $t('intentsList.import') }}
            </md-button> -->
          </md-card-header>
          <md-card-content>
            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              :md-selected-value.sync="selected"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="pages">{{ $t('intentsList.perPage') }}</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>

                <md-field>
                  <md-input
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px;"
                    :placeholder="$t('intentsList.search') + '...'"
                    :value="searchQuery"
                    @input="updateSearch"
                  ></md-input>
                </md-field>
              </md-table-toolbar>

              <md-table-toolbar
                slot="md-table-alternate-header"
                slot-scope="{ count }"
                style="position: relative;"
              >
                <div class="backgroundRed md-toolbar">
                  <div class="md-toolbar-section-start">
                    {{ count }}
                    {{
                      count > 1
                        ? $t('intentsList.itemsSelected')
                        : $t('intentsList.itemSelected')
                    }}
                  </div>

                  <div class="md-toolbar-section-end">
                    <!-- <md-button
                      :disabled="isNotCheckedOut"
                      class="md-simple md-github"
                    >
                      <md-icon>get_app</md-icon>
                      {{ $t('intentsList.export') }}
                    </md-button> -->
                    <md-button
                      :disabled="isNotCheckedOut"
                      class="md-simple md-github"
                      @click="handleDelete"
                    >
                      <md-icon>delete</md-icon>
                      {{ $t('intentsList.delete') }}
                    </md-button>
                    <md-button
                      class="md-simple md-github"
                      @click="clearSelection"
                      >{{ $t('intentsList.cancel') }}</md-button
                    >
                  </div>
                </div>
              </md-table-toolbar>

              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                md-selectable="multiple"
                @click="editItem(item)"
                style="cursor: pointer;"
              >
                <md-table-cell
                  :md-label="$t('intentsList.intentName')"
                  md-sort-by="intent"
                  style="color: #4caf50;"
                >
                  #{{ item.intent }}
                </md-table-cell>
                <md-table-cell :md-label="$t('intentsList.description')">
                  {{ item.description }}
                </md-table-cell>
                <md-table-cell :md-label="$t('intentsList.examples')">
                  <div class="ellipsis">
                    {{ item.examples.map((ex) => `"${ex.text}"`).join(', ') }}
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                {{
                  $t('intentsList.showingItems', {
                    from: from + 1,
                    to: to,
                    total: total,
                  })
                }}
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
    <v-dialog v-model="createDialog" max-width="700px" :scrollable="true">
      <CreateIntentDialog
        :key="keyCreate"
        @save="saveIntent"
        @close-create-dialog="createDialog = false"
      />
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      fullscreen
      max-width="700px"
      persistent
      :scrollable="true"
    >
      <EditIntentDialog
        v-if="editDialog"
        :item="itemToEdit"
        @save="saveIntent"
        @close-edit-dialog="editDialog = false"
      />
    </v-dialog>
  </span>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import Fuse from 'fuse.js'
import Swal from 'sweetalert2'
import CreateIntentDialog from '@/components/CreateIntentDialog.vue'
import EditIntentDialog from '@/components/EditIntentDialog.vue'
import debounce from 'lodash/debounce'

export default {
  model: {
    prop: 'intents',
    event: 'update'
  },
  props: {
    intents: { required: true, type: Array },
    viewingMode: { required: true, type: Boolean }
  },
  components: {
    Pagination,
    CreateIntentDialog,
    EditIntentDialog
  },
  computed: {
    intentsNames () {
      return this.intents.map((i) => i.intent)
    },
    searchedData () {
      // console.log(`searched data changed`)
      return this.searchQuery !== ''
        ? this.fuseSearch.search(this.searchQuery)
        : this.intents
    },
    queriedData () {
      return this.searchedData.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.searchedData?.length || this.intents.length
    },
    isNotCheckedOut () {
      return (
        this.$store.state.snapshots.appliedSnapshot._source.status !==
          'checkedout' || this.viewingMode === true
      )
    }
  },
  data () {
    return {
      editItemIndex: null,
      currentSort: 'intent',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['intent', 'examples.text'],
      fuseSearch: null,
      icons: {
        createButton: require('../../public/img/plus.png'),
        pencil: require('../../public/img/pencil-icon.png')
      },
      selected: [],
      createDialog: false,
      keyCreate: 0,
      editDialog: false,
      itemToEdit: '',
      keyEdit: 0
    }
  },
  methods: {
    updateSearch: debounce(function (value) {
      this.searchQuery = value
    }, 366),
    clearSelection () {
      this.selected = []
    },
    customSort (value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === 'desc') {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    handleDelete (item) {
      Swal.fire({
        title: this.$t('intents.areYouSure'),
        text: this.$t('intents.youWontBeAbleToRevertThis'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: this.$t('intents.yesDeleteIt'),
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          const names = this.selected.map((e) => e.intent).join(', ') + '.'
          this.deleteSelected()
          Swal.fire({
            title: this.$t('intents.deleted'),
            text: `${this.$t('intents.youDeleted')} ${names}`,
            type: 'success',
            confirmButtonClass: 'md-button md-success btn-fill',
            buttonsStyling: false
          })
        }
      })
    },
    async deleteSelected () {
      const checkedOutSnap = this.$store.getters['snapshots/checkedOutByUser']
      const intents = this.intents.filter(
        (intent) => !this.selected.includes(intent)
      )
      await this.$store.dispatch('snapshots/save', {
        id: checkedOutSnap._id,
        data: {
          intents
        }
      })
      // console.log(`deleted intents`, response)
      this.clearSelection()
      this.updateFuse(intents)
      this.$emit('update', intents)
    },
    deleteRow (item) {
      let indexToDelete = this.intents.findIndex(
        (tableRow) => tableRow.id === item.id
      )
      if (indexToDelete >= 0) {
        this.intents.splice(indexToDelete, 1)
      }
    },
    goTo (path) {
      this.$router.push(path)
    },
    toIntentPage () {
      this.$router.push('/intent-edit')
    },
    onSelect (items) {
      this.selected = items
    },
    editItem (item) {
      this.itemToEdit = item
      this.editItemIndex = this.intents.findIndex(intent => intent.intent === item.intent)
      this.editDialog = true
    },
    async saveIntent (newIntentData) {
      const checkedOutSnap = this.$store.getters['snapshots/checkedOutByUser']
      const before = []
      if (this.itemToEdit) {
        before.push(this.itemToEdit)
        if (newIntentData.intent !== this.itemToEdit.intent) {
          const hasIntent = this.intents.some(currentIntent => currentIntent.intent === newIntentData.intent)
          if (hasIntent) {
            Swal.fire({
              icon: 'error',
              title: this.$t('intents.intentError'),
              text: this.$t('intents.thereIsAlreadyIntentionRegistered'),
              showConfirmButton: true
            })
            return
          }
        }

        this.$set(this.intents, this.editItemIndex, newIntentData)
        const hasIntentExample = this.hasExistIntentExample({ intentBeforeSave: this.itemToEdit, intentAfterSave: newIntentData })
        if (hasIntentExample) {
          Swal.fire({
            icon: 'error',
            title: this.$t('intents.intentError'),
            text: this.$t('intents.theRegistrationExample'),
            showConfirmButton: true
          })
          return
        }
      } else {
        // console.log(newIntentData)
        const hasIntent = this.intents.some(currentIntent => currentIntent.intent === newIntentData.intent)
        if (hasIntent) {
          Swal.fire({
            icon: 'error',
            title: this.$t('intents.intentError'),
            text: this.$t('intents.thereIsAlreadyIntentionRegistered'),
            showConfirmButton: true
          })
          return
        }

        this.intents.push(newIntentData)
      }
      await this.$store.dispatch('snapshots/save', {
        id: checkedOutSnap._id,
        data: {
          intents: this.intents
        }
      })
      // console.log(`saved intent!`, response)
      this.updateFuse(this.intents)
      this.editDialog = false
      this.itemToEdit = null
    },
    hasExistIntentExample ({ intentBeforeSave, intentAfterSave }) {
      const newExamples = intentAfterSave?.examples.filter(currentExample => !intentBeforeSave.examples.some(exampleBeforeSave =>
        currentExample.text === exampleBeforeSave.text
      ))
      const hasIntentExample = this.intents.some(currentIntent => {
        return newExamples.some(currentExampleToSave => currentIntent.examples.some(currentExample => {
          return currentExampleToSave.text === currentExample.text && currentIntent.intent !== intentAfterSave.intent
        }))
      })
      return hasIntentExample
    },
    updateFuse (intents) {
      this.fuseSearch = new Fuse(intents, {
        keys: ['intent', 'description'],
        threshold: 0.3
      })
    }
  },
  mounted () {
    this.updateFuse(this.intents)
  }
}
</script>

<style lang="css">
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #33b231 !important;
  top: 1px !important;
  left: 6px !important;
}
table {
  table-layout: fixed;
}
table
  thead
  tr
  .md-table-cell-selection
  .md-table-head-container
  .md-table-head-label {
  padding-right: 0px;
}
.md-table-alternate-header {
  top: auto;
}
.backgroundRed {
  background-color: rgba(255, 82, 82, 0.2) !important;
  border-radius: 0px !important;
  box-shadow: none !important;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100% !important;
  height: 56px !important;
  position: absolute !important;
  top: 0 !important;
}
.backgroundRed:hover {
  color: rgba(0, 0, 0, 0.87) !important;
}
.inlineTitle {
  display: inline-block;
}
.rightJustify {
  position: absolute !important;
  right: 4px !important;
}
.ellipsis {
  text-overflow: ellipsis;

  /* Required for text-overflow to do anything */
  white-space: nowrap;
  overflow: hidden;
}
</style>
